import React from 'react';
import './PromocodeText.less';

export const PromocodeText = ({text}) => {
	return <span className="promocode-text">{text}</span>;
};
